// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QrL7r","type":"styles_type__1iMIB","choices":"styles_choices__3o2xg"};